<template>
  <div v-if="!!entity">
    <div class="row mb-3 mt-3">
      <div class="col-sm-4"><h1></h1></div>
      <div class="col-sm-4 d-none d-lg-block"><h3>Stranka</h3></div>
      <div class="col-sm-4 text-end"></div>
    </div>
    <div class="row mb-3">
      <label class="col-form-label col-sm-4">Naziv</label>
      <div class="col-sm-8">
        <input class="form-control" type="text" v-model="entity.fullName" :disabled="!canChange" required />
      </div>
    </div>
    <div class="row mb-3">
      <label class="col-form-label col-sm-4">Kratek naziv</label>
      <div class="col-sm-8">
        <input class="form-control" type="text" v-model="entity.shortName" :disabled="!canChange" required />
      </div>
    </div>
    <div class="row mb-3">
      <label class="col-form-label col-sm-4">Naslov</label>
      <div class="col-sm-8">
        <input class="form-control" type="text" v-model="entity.address" :disabled="!canChange" required />
      </div>
    </div>

   <RequiredWarning v-show="!isValid && canChange" />

    <div class="row mb-5">
      <div class="col-2 text-start">
      </div>
      <div class="col-10 text-end">
        <button class="btn btn-outline-secondary me-3" type="button" @click="$router.push({ name: 'Facilities' })">Prekliči</button>
        <button  v-show="false" class="btn btn-success btn-lg me-3" type="button" @click="saveEntityAsync" :disabled="!isValid || !canChange">Shrani</button>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col">
          <ul>
            <li v-for="f in facilities">
              <router-link :to="{ name: 'FacilityEdit', params: { facilityId: f.id } }" target="blank">{{ f.name }}</router-link>
            </li>
          </ul>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { getEntityAsync, listEntitiesAsync } from "../api"
import { EMPTY_GUID } from "../utils/constants"
import {
  useAuth,
  authState,
  isAuthenticated,
  user,
  role,
  isAdmin,
  showMessageToWorker,
} from "../composition-api/useAuth"

defineOptions({ name: "CustomerEdit" })

const route = VueRouter.useRoute()
const { fetchAuthAsync } = useAuth()

const entity = ref()
const facilities = ref([])

const isNew = computed(() => route.params.deviceId === "new")
const canChange = computed(() => isAdmin.value)
const isValid = computed(
  () =>
    entity.value?.fullName?.length > 0 && entity.value?.shortName?.length > 0 && entity.value?.address?.length > 0,
)

const loadEntityAsync = async () => {
  console.log("Loading customer", route.params.customerId)
  facilities.value = await listEntitiesAsync(
    fetchAuthAsync,
    "Facilities",
    `?variant=Full&customerId=${route.params.customerId}`,
  )
  entity.value = await getEntityAsync(fetchAuthAsync, "Customers", route.params.customerId)
}

const saveEntityAsync = async () => {
  const result = await saveCustomerAsync(fetchAuthAsync, entity.value, isNew.value)
  if (!result) return
  if (isNew.value) {
    router.push({ name: "CustomerEdit", params: { customerId: entity.value.id, keepMessages: true } })
  } else {
    await loadEntityAsync()
  }
}

watch(
  () => route.params.customerId,
  () => loadEntityAsync(),
)

onMounted(async () => {
  await loadEntityAsync()
})
</script>
